import React from "react"
import ReactDOM from "react-dom"
import { NEFThemeProvider } from "@nef/core"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"

import "./index.css"
import "./index.scss"
import App from "./App"
import { persistor, store } from "./app/store"
import AuthProvider from "./AuthProvider"

ReactDOM.render(
  <React.StrictMode>
    <NEFThemeProvider>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AuthProvider>
              <App />
            </AuthProvider>
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </NEFThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
